import axios from 'axios';
import {
  GET_COMMUNICATION_SETTINGS_REQUEST,
  GET_COMMUNICATION_SETTINGS_SUCCESS,
  GET_COMMUNICATION_SETTINGS_FAILURE,

  GET_DISPLAY_COMMUNICATION_SETTINGS_REQUEST,
  GET_DISPLAY_COMMUNICATION_SETTINGS_SUCCESS,
  GET_DISPLAY_COMMUNICATION_SETTINGS_FAILURE,

  UPDATE_COMMUNICATION_SETTINGS_REQUEST,
  UPDATE_COMMUNICATION_SETTINGS_SUCCESS,
  UPDATE_COMMUNICATION_SETTINGS_FAILURE
} from 'Store/constants';

import errorMessage from './errorMessage';

let getSettingsInFlight = null;

export const getCommunicationSettings = () => async (dispatch, getState) => {
  try {
    // Return cached if already fetched
    const cached = getState()?.communicationSettings?.data;
    const hasCachedCore = cached && (Object.prototype.hasOwnProperty.call(cached, 'campaignEmail') || Object.prototype.hasOwnProperty.call(cached, 'campaignSms'));
    if (hasCachedCore) return { data: cached };

    // De-dupe concurrent requests
    if (getSettingsInFlight) return getSettingsInFlight;

    dispatch({
      type: GET_COMMUNICATION_SETTINGS_REQUEST
    });

    const request = axios.get('/contact-permissions').finally(() => {
      getSettingsInFlight = null;
    });
    getSettingsInFlight = request;
    const res = await request;


    dispatch({
      type: GET_COMMUNICATION_SETTINGS_SUCCESS,
      payload: res.data
    });

    return res;

  } catch (e) {
    console.log('error', e);

    dispatch({
      type: GET_COMMUNICATION_SETTINGS_FAILURE,
      payload: errorMessage
    });
  }
};

let getDisplayInFlight = null;

export const getDisplayCommunicationSettings = () => async dispatch => {
  try {
    // De-dupe concurrent requests
    if (getDisplayInFlight) return getDisplayInFlight;

    dispatch({
      type: GET_DISPLAY_COMMUNICATION_SETTINGS_REQUEST
    });

    const request = axios.get('/contact-permissions/check').finally(() => {
      getDisplayInFlight = null;
    });
    getDisplayInFlight = request;
    const res = await request;
    dispatch({
      type: GET_DISPLAY_COMMUNICATION_SETTINGS_SUCCESS,
      payload: res.data
    });

    return res;

  } catch (e) {
    console.log('error', e);

    dispatch({
      type: GET_DISPLAY_COMMUNICATION_SETTINGS_FAILURE,
      payload: errorMessage
    });
  }
};

export const updateCommunicationSettings = newSettings => async dispatch => {
  try {
    dispatch({
      type: UPDATE_COMMUNICATION_SETTINGS_REQUEST
    });

    const res = await axios.put('/contact-permissions', newSettings);

    dispatch({
      type: UPDATE_COMMUNICATION_SETTINGS_SUCCESS,
      payload: res.data
    });

    return res;

  } catch (e) {
    console.log('error', e);

    dispatch({
      type: UPDATE_COMMUNICATION_SETTINGS_FAILURE,
      payload: errorMessage
    });
  }
};

